import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes.consts";
import { useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { RightChevron } from "../../../svgs";
import { isMobile } from "react-device-detect";
export const UnauthHeaderLayout = ({
  isSubmitPage,
}: {
  isSubmitPage?: any;
}) => {

  const location = useLocation();

  const navigate = useNavigate();
  const handleConnect = async () => {
    // window.location.href = "http://localhost:9090/api/auth/login?page=DASHBOARD";
    window.location.href = "https://staging-api.pitchplaylists.com/api/auth/login?page=DASHBOARD";
    //window.location.href = "https://api.pitchplaylists.com/api/auth/login?page=DASHBOARD";

  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <div className={`relative site-header-wrapper ${location.pathname.includes("callback") ? 'z-0' : 'z-[1]'}`}>
        <header className="site-header">
          <div
            className={`header-blocks ${location.pathname.includes("submit-public-page")
                ? "flex items-center justify-center"
                : ""
              }`}
          >
            <div
              className={`header-block__logo ${location.pathname.includes("submit-public-page")
                  ? "flex items-center justify-center"
                  : ""
                }`}
            >
              <Link to={ROUTES.HOME} className="md:max-w-[230px] max-w-[175px]">
                {location.pathname.includes("public") ? (
                  <img
                    src="https://pitchplaylists.com/blog/wp-content/uploads/2025/03/pitchplaylists-logo.png"
                    className="header-logo img-full object-contain !block"
                    alt="PitchPlaylist logo"
                    title="PitchPlaylist logo"
                    width={230}
                    height={40.47}
                    loading="lazy"
                  />
                ) : (
                  <>
                    <img
                      src="https://pitchplaylists.com/blog/wp-content/uploads/2025/03/pitchplaylists-logo.png"
                      className="header-logo img-full object-contain"
                      alt="PitchPlaylist logo"
                      title="PitchPlaylist logo"
                      width={230}
                      height={40.47}
                      loading="lazy"
                    />
                    <img
                      src="https://pitchplaylists.com/blog/wp-content/uploads/2025/03/pitchplaylists-logo-mobile.png"
                      className="header-logo-mobile img-full object-contain w-[40px] h-[40px]"
                      alt="PitchPlaylist logo"
                      title="PitchPlaylist logo"
                      width={40}
                      height={40}
                      loading="lazy"
                    />
                  </>
                )}
              </Link>
            </div>
            {!location.pathname.includes("submit-public-page") && (
              <>
                <nav className="header-block__nav">
                  <ul>
                    <li
                      className={
                        location.pathname === ROUTES.HOME
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <Link to={ROUTES.HOME}>Home</Link>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.CONTACT
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <Link to={ROUTES.CONTACT}>Contact Us</Link>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.FEATURES
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <button
                        onClick={() => {
                          if (location.pathname != "/") {
                            navigate("/");
                          }
                          setTimeout(() => {
                            document
                              .querySelector("#features")
                              ?.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                              });
                          }, 50);
                        }}
                      >
                        Features
                      </button>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.TOP_PLAYLISTS
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <button
                        onClick={() => {
                          if (location.pathname != "/") {
                            navigate("/");
                          }
                          setTimeout(() => {
                            document
                              .querySelector("#top-playlists")
                              ?.scrollIntoView({
                                behavior: "smooth",
                              });
                          }, 50);
                        }}
                      >
                        Top Playlists
                      </button>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.BLOG
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <a href={ROUTES.BLOG}>Blog</a>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.REVIEWS
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <Link to={ROUTES.REVIEWS}>Reviews</Link>
                    </li>
                    <li
                      className={
                        location.pathname === ROUTES.FAQ
                          ? "menu-item current_page_item"
                          : "menu-item"
                      }
                    >
                      <Link to={ROUTES.FAQ}>Faq</Link>
                    </li>
                  </ul>
                </nav>
                <div className="header-block__button text-right">
                  <button
                    className="button button--secondary button--with-icon header-button"
                    onClick={handleConnect}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5891 0.444806C7.40374 0.122281 0.504868 6.43839 0.180869 14.5526C-0.144486 22.6667 6.2284 29.5043 14.4124 29.8268C22.5978 30.1493 29.4953 23.8332 29.8207 15.719C30.1447 7.60485 23.7732 0.765986 15.5891 0.444806ZM21.8495 21.9841C21.6651 22.3066 21.3059 22.4679 20.9561 22.4195C20.849 22.4047 20.7419 22.3698 20.6416 22.3133C18.6814 21.2073 16.5449 20.487 14.2918 20.1726C12.0387 19.8581 9.78426 19.9669 7.59218 20.4951C7.11635 20.6093 6.63781 20.3204 6.52258 19.8487C6.40735 19.377 6.69881 18.9026 7.17464 18.7884C9.58498 18.2078 12.0631 18.0882 14.5385 18.4336C17.0139 18.779 19.3619 19.5705 21.5187 20.7867C21.943 21.0272 22.0922 21.5621 21.8509 21.9841H21.8495ZM23.7989 18.1245C23.4966 18.6782 22.7971 18.8851 22.2386 18.5855C19.9448 17.3558 17.4613 16.5482 14.8571 16.1853C12.2529 15.8225 9.64192 15.9206 7.09466 16.4756C6.95638 16.5052 6.81946 16.5106 6.68661 16.4917C6.22433 16.4272 5.82849 16.0859 5.72275 15.6061C5.58583 14.9907 5.97896 14.3819 6.59985 14.2462C9.41552 13.632 12.3017 13.5232 15.1784 13.9236C18.0537 14.3241 20.7989 15.2164 23.3339 16.5764C23.8938 16.8761 24.1012 17.5682 23.7989 18.1232V18.1245ZM25.9598 13.7731C25.6751 14.316 25.0827 14.5969 24.5052 14.5163C24.3493 14.4948 24.1961 14.4464 24.0484 14.3711C21.3777 12.9937 18.5011 12.0839 15.4983 11.666C12.4955 11.248 9.47653 11.3367 6.52664 11.9307C5.75935 12.0853 5.01239 11.5934 4.85649 10.8341C4.70059 10.0735 5.19676 9.33304 5.96269 9.1785C9.2298 8.52136 12.5701 8.42326 15.8928 8.88554C19.2155 9.34783 22.3985 10.3557 25.3566 11.881C26.0506 12.2385 26.3204 13.0864 25.9598 13.7745V13.7731Z"
                        fill="white"
                      />
                    </svg>
                    <span>Connect with Spotify</span>
                  </button>
                </div>
                <button
                  className="mobile-menu__trigger"
                  onClick={() => setIsMobileMenuOpen(true)}
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1H17M1 11H17M1 6H17"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </>
            )}
          </div>
        </header>

        <Dialog
          open={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        >
          <DialogBackdrop
            className="fixed inset-0 bg-[#052437]/20 backdrop-blur-[20px]"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <DialogPanel className="mobile-menu__wrapper p-4">
            <p className="mobile-menu__heading text-white">Menu</p>
            <ul>
              <li
                className={
                  location.pathname === ROUTES.HOME
                    ? "menu-item current_page_item text-[#58F2A9]"
                    : "menu-item text-white"
                }
              >
                <button
                  className="text-current flex items-center justify-between"
                  onClick={() => {
                    navigate(ROUTES.HOME);
                    setIsMobileMenuOpen(false);
                  }}
                >
                  Home
                  <RightChevron
                    width={13}
                    height={13}
                    opacity={location.pathname === ROUTES.HOME ? 1 : 0.5}
                  />
                </button>
              </li>
              <li
                className={
                  location.pathname === ROUTES.CONTACT
                    ? "menu-item current_page_item text-[#58F2A9]"
                    : "menu-item text-white"
                }
              >
                <button
                  onClick={() => {
                    navigate(ROUTES.CONTACT);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-current flex items-center justify-between"
                >
                  Contact Us
                  <RightChevron
                    width={13}
                    height={13}
                    opacity={location.pathname === ROUTES.CONTACT ? 1 : 0.5}
                  />
                </button>
              </li>
              <li
                className={
                  location.pathname === ROUTES.FEATURES
                    ? "menu-item current_page_item"
                    : "menu-item text-white"
                }
              >
                <button
                  className="py-3 w-full border-b border-[#878da133] text-start text-white flex items-center justify-between"
                  onClick={() => {
                    if (location.pathname != "/") {
                      navigate("/");
                    }
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                      document.querySelector("#features")?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }, 50);
                  }}
                >
                  Features
                  <RightChevron width={13} height={13} opacity={0.5} />
                </button>
              </li>
              <li
                className={
                  location.pathname === ROUTES.TOP_PLAYLISTS
                    ? "menu-item current_page_item"
                    : "menu-item"
                }
              >
                <button
                  className="py-3 w-full border-b border-[#878da133] text-start text-white flex items-center justify-between"
                  onClick={() => {
                    if (location.pathname != "/") {
                      navigate("/");
                    }
                    setIsMobileMenuOpen(false);
                    setTimeout(() => {
                      document.querySelector("#top-playlists")?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 50);
                  }}
                >
                  Top Playlists
                  <RightChevron width={13} height={13} opacity={0.5} />
                </button>
              </li>
              <li
                className={
                  location.pathname === ROUTES.BLOG
                    ? "menu-item current_page_item"
                    : "menu-item"
                }
              >
                <a
                  href="https://pitchplaylists.com/blog/"
                  className="flex items-center justify-between"
                >
                  Blog
                  <RightChevron width={13} height={13} opacity={0.5} />
                </a>
              </li>
              <li
                className={
                  location.pathname === ROUTES.REVIEWS
                    ? "menu-item current_page_item text-[#58F2A9]"
                    : "menu-item text-white"
                }
              >
                <button
                  onClick={() => {
                    navigate(ROUTES.REVIEWS);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-current flex items-center justify-between"
                >
                  Reviews
                  <RightChevron
                    width={13}
                    height={13}
                    opacity={location.pathname === ROUTES.REVIEWS ? 1 : 0.5}
                  />
                </button>
              </li>
              <li
                className={
                  location.pathname === ROUTES.FAQ
                    ? "menu-item current_page_item text-[#58F2A9]"
                    : "menu-item text-white"
                }
              >
                <button
                  onClick={() => {
                    navigate(ROUTES.FAQ);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-current flex items-center justify-between"
                >
                  Faq
                  <RightChevron
                    width={13}
                    height={13}
                    opacity={location.pathname === ROUTES.FAQ ? 1 : 0.5}
                  />
                </button>
              </li>
            </ul>
            <button
              className="button button--secondary button--with-icon header-button max-sm:gap-2"
              onClick={handleConnect}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="!size-6"
              >
                <path
                  d="M15.5891 0.444806C7.40374 0.122281 0.504868 6.43839 0.180869 14.5526C-0.144486 22.6667 6.2284 29.5043 14.4124 29.8268C22.5978 30.1493 29.4953 23.8332 29.8207 15.719C30.1447 7.60485 23.7732 0.765986 15.5891 0.444806ZM21.8495 21.9841C21.6651 22.3066 21.3059 22.4679 20.9561 22.4195C20.849 22.4047 20.7419 22.3698 20.6416 22.3133C18.6814 21.2073 16.5449 20.487 14.2918 20.1726C12.0387 19.8581 9.78426 19.9669 7.59218 20.4951C7.11635 20.6093 6.63781 20.3204 6.52258 19.8487C6.40735 19.377 6.69881 18.9026 7.17464 18.7884C9.58498 18.2078 12.0631 18.0882 14.5385 18.4336C17.0139 18.779 19.3619 19.5705 21.5187 20.7867C21.943 21.0272 22.0922 21.5621 21.8509 21.9841H21.8495ZM23.7989 18.1245C23.4966 18.6782 22.7971 18.8851 22.2386 18.5855C19.9448 17.3558 17.4613 16.5482 14.8571 16.1853C12.2529 15.8225 9.64192 15.9206 7.09466 16.4756C6.95638 16.5052 6.81946 16.5106 6.68661 16.4917C6.22433 16.4272 5.82849 16.0859 5.72275 15.6061C5.58583 14.9907 5.97896 14.3819 6.59985 14.2462C9.41552 13.632 12.3017 13.5232 15.1784 13.9236C18.0537 14.3241 20.7989 15.2164 23.3339 16.5764C23.8938 16.8761 24.1012 17.5682 23.7989 18.1232V18.1245ZM25.9598 13.7731C25.6751 14.316 25.0827 14.5969 24.5052 14.5163C24.3493 14.4948 24.1961 14.4464 24.0484 14.3711C21.3777 12.9937 18.5011 12.0839 15.4983 11.666C12.4955 11.248 9.47653 11.3367 6.52664 11.9307C5.75935 12.0853 5.01239 11.5934 4.85649 10.8341C4.70059 10.0735 5.19676 9.33304 5.96269 9.1785C9.2298 8.52136 12.5701 8.42326 15.8928 8.88554C19.2155 9.34783 22.3985 10.3557 25.3566 11.881C26.0506 12.2385 26.3204 13.0864 25.9598 13.7745V13.7731Z"
                  fill="white"
                />
              </svg>
              <span>Connect with Spotify</span>
            </button>
          </DialogPanel>
        </Dialog>
      </div>
    </>
  );
};
